<template>
  <div>
    <div class="page_title flex_between">
      <span>名家医案</span>

      <el-button
        type="primary"
        style="width:92px;"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="essaybox">
          <div class="title">{{detail.title}}</div>
          <div class="author">作者：{{detail.author}}</div>

          <div v-html="detail.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgtext from '../../../api/imgtext';
export default {
  data() {
    return {
      detail: {}
    };
  },

  methods: {
    //获取图文信息
    getDetail() {
      let art_id = this.$route.query.art_id;
      imgtext.getFamousMedicalRecordsInfo({ art_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.detail.content = this.detail.content.replace(
            /<img/g,
            "<img style='width:100%'"
          );
          this.detail.content = this.detail.content.replace(
            /<video/g,
            "<video style='width:100%'"
          );
        }
      });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.essaybox {
  width: 70%;
  padding: 30px 50px;
  box-sizing: border-box;
  border: solid 2px #cfcece;
  margin: 20px auto 0;
  text-align: left;
  min-height: calc(100vh - 240px);

  .title {
    font-size: 18px;
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .author {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>

